/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CheckIn1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import CheckIn from 'DesignSystem/CheckIn/index'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function CheckIn1({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Scheduled/Primary/Content/CheckIn"
  
}) {
let eventAppointmentBookingValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking',
})
let globalCurrentLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location._id',
})
let tabPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'patient_id',
})
  return (<React.Fragment
>
<CheckIn
  viewPath={`${viewPath}/CheckIn`}
 data="event.appointment.booking"
 appointmentBooking={eventAppointmentBookingValueData}
 data="global.current_location._id"
 locationId={globalCurrentLocationIdValueData}
 data="tab.patient_id"
 patientId={tabPatientIdValueData}
>
{childProps => (
<TysiaButtonWithText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="secondary"
 marginLeft={4}
 size="small"
 text="Check in"
/>
)}
</CheckIn>
{children}
</React.Fragment>)
}